import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IdName } from '@api/models/idname';

@Component({
  selector: 'flow-chart-custom-labels',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './chart-custom-labels.component.html',
  styleUrls: ['./chart-custom-labels.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartCustomLabelsComponent implements OnDestroy {
  destroy$ = new Subject<void>();
  @Input() data: IdName[] = [];
  @Input() selectedMediaIndex: number = 0;
  @Input() showCount: boolean = false;
  @Output() selectedIndex = new EventEmitter<{ item: IdName; index: number }>();

  constructor(private translateService: TranslateService) {
    this.translateService.onLangChange.pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.selectMedia(null, null);
    });
  }

  selectMedia(item: IdName, index: number) {
    this.selectedIndex.emit({ item, index });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
